import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ReportPdfModel } from '../../models/index';

@Component({
    selector: 'report-list-table',
    templateUrl: 'report-pdf-list.component.html',
    standalone: false
})
export class ReportPdfListComponent {
  @Input() public reports: ReportPdfModel[];
  @Input() public sendReport: boolean;
  @Output() public toggleSelectReport: EventEmitter<any> = new EventEmitter();
  @Output() public toggleShareReport: EventEmitter<any> = new EventEmitter();
  public selection: any = {};
  errorMessage: string;
  orderByFieldName = 'generationDate';
  direction = 'desc';
  @Input() query = '';
  public loading: Boolean = true;

  constructor() {}

  public downloadReport(report: ReportPdfModel) {
    this.toggleSelectReport.emit(report);
  }

  public shareReport(report: ReportPdfModel) {
    this.toggleShareReport.emit(report);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }
}
